import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { firebaseGetToken } from '~/services/firebase';

// Request interceptors
export const addAuthHeader = async (cfg: AxiosRequestConfig) => {
  const token = await firebaseGetToken();
  if (token) {
    // eslint-disable-next-line no-param-reassign
    cfg.headers.authorization = `Bearer ${token}`;
  }

  return cfg;
};

// Response interceptors
export const handleDefaultResponse = (res: AxiosResponse) => res.data;

export const handleUnauthorizedError = () => (error: AxiosError) => {
  const { config: originalRequest, response: { status } = { status: null } } =
    error;

  if (
    status === 401 &&
    !['/auth/user', '/check-session', '/clear-session'].includes(
      originalRequest.url,
    )
  ) {
    window.location.reload();
  }

  throw error;
};
